module.exports = "/assets/d876cab13e99f08183717476c0f58b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KO.png
// module id = 1552
// module chunks = 0